import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';

import Checkbox from 'app/components/shared/Checkbox';
import { getLabel } from 'app/helpers/facets/filterUtils';
import '../styles/CheckboxFilter.scss';

class CheckboxFilter extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleToggleFilter(_checked, { value: filter }) {
    this.props.handleToggleFilter(this.props.fieldId, filter);
  }

  render() {
    const { fieldId, filter, id, intl } = this.props;
    const value = filter.get('value');
    const label = filter.get('label');
    const count = filter.get('count');
    const applied = filter.get('applied');

    const filterLabel = getLabel(intl, fieldId, label || value);
    const formattedLabel = intl.formatMessage({ id: 'Facets.filterLabelFormat' }, { value: filterLabel, count });

    return (
      <Checkbox
        checked={applied}
        dataKey="checkbox-filter"
        handleChange={this.handleToggleFilter}
        id={id}
        label={formattedLabel}
        value={filter}
      />
    );
  }
}
CheckboxFilter.propTypes = {
  fieldId: PropTypes.string.isRequired,
  filter: ImmutablePropTypes.map.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
};

export default injectIntl(CheckboxFilter);
